import { render, staticRenderFns } from "./DossierDetail.vue?vue&type=template&id=178032f2&"
import script from "./DossierDetail.vue?vue&type=script&lang=js&"
export * from "./DossierDetail.vue?vue&type=script&lang=js&"
import style0 from "./DossierDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports